import { getConversationLegacyRoute } from '@/api/conversation'

export type LegacyConversationOrigin = 'legacy-search' | 'legacy-marketing'

export type LegacyConversationBookmark =
  | { disposition: 'legacy'; readOnly: false }
  | { disposition: 'read-only'; readOnly: true }
  | { disposition: 'redirect'; readOnly: true; conversationId: number }

export async function resolveLegacyConversationBookmark(
  projectId: number,
  threadId: number,
  expectedOrigin: LegacyConversationOrigin
): Promise<LegacyConversationBookmark> {
  const resolution = await getConversationLegacyRoute(projectId, threadId)
  if (resolution === undefined) return { disposition: 'legacy', readOnly: false }
  if (resolution.originKind !== expectedOrigin) throw new Error('Conversation resource not found.')
  if (resolution.disposition === 'redirect') {
    if (resolution.conversationId === undefined || resolution.conversationId !== threadId) {
      throw new Error('Conversation resource not found.')
    }
    return { disposition: 'redirect', readOnly: true, conversationId: resolution.conversationId }
  }
  if (resolution.disposition === 'read-only') return { disposition: 'read-only', readOnly: true }
  return { disposition: 'legacy', readOnly: false }
}
